import { ModalBody as _ModalBody, ModalBodyProps as _ModalBodyProps } from "reactstrap";

    export const ModalBody = _ModalBody;
    export type ModalBodyProps = _ModalBodyProps;
    